export const BookingServicesCategory: Record<
  string,
  {
    plural?: string;
    singular: string;
    icon: string;
  }
> = {
  HBAG: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.hbag',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.hbag',
    icon: 'ds-icon-handbag'
  },
  SEAT: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.seat',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.seat',
    icon: 'ds-icon-seat'
  },
  PETC: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.petc',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.petc',
    icon: ' ds-icon-pet'
  },
  BG15: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg15',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg15',
    icon: 'ds-icon-checked-bag'
  },
  BG20: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg20',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg20',
    icon: 'ds-icon-checked-bag'
  },
  BG23: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg23',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg23',
    icon: 'ds-icon-checked-bag'
  },
  BG25: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg25',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg25',
    icon: 'ds-icon-checked-bag'
  },
  BG30: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg30',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg30',
    icon: 'ds-icon-checked-bag'
  },
  BX15: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg15',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg15',
    icon: 'ds-icon-checked-bag'
  },
  BX20: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg20',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg20',
    icon: 'ds-icon-checked-bag'
  },

  BX25: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg25',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg25',
    icon: 'ds-icon-checked-bag'
  },
  BX30: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.bg30',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.bg30',
    icon: 'ds-icon-checked-bag'
  },
  GBR1: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.gbr1',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.gbr1',
    icon: 'ds-icon-priority-boarding'
  },
  FAST: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.fast',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.fast',
    icon: 'ds-icon-fast-lane'
  },
  GCBG: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.gcbg',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.gcbg',
    icon: 'ds-icon-cabin-bag'
  },
  NGCB: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.gcbg',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.plural.gcbg',
    icon: 'ds-icon-cabin-bag'
  },
  SPEQ: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  BIKE: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  SPWS: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  SPTS: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  SPSW: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  SPSK: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  SPKB: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  SPIM: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  SPBG: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.spec',
    icon: 'ds-icon-special-lugagge'
  },
  WEAP: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.weap',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.weap',
    icon: 'ds-icon-special-lugagge'
  },
  VCB2: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.vcb2',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.vcb2',
    icon: 'ds-icon-special-lugagge'
  },
  VCB3: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.vcb3',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.vcb3',
    icon: 'ds-icon-special-lugagge'
  },
  VYOP: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.vyop',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.vyop',
    icon: 'ds-icon-special-lugagge'
  },
  VYTF: {
    singular:
      'booking_details_component.booking_services_component.service_categories.passenger_services.singular.vytf',
    plural: 'booking_details_component.booking_services_component.service_categories.passenger_services.singular.vytf',
    icon: 'ds-icon-special-lugagge'
  },
  EXST: {
    singular: 'cdk.searcher.pax.paxTypes.extraseats.singular',
    plural: 'cdk.searcher.pax.paxTypes.extraseats.plural',
    icon: 'ds-icon-seat'
  },
  PRBZ: {
    singular: 'PRBZ',
    plural: 'PRBZ',
    icon: 'ds-icon-seat'
  },
  RFCS: {
    singular: 'booking_details_component.other_services_component.booking_services.rfcs',
    plural: 'booking_details_component.other_services_component.booking_services.rfcs',
    icon: 'ds-icon-error'
  },
  FVFJ: {
    singular: 'booking_details_component.other_services_component.booking_services.fvfj',
    plural: 'booking_details_component.other_services_component.booking_services.fvfj',
    icon: 'ds-icon-plane-flight-change'
  }
};
